import { Box, Container, Stack, Typography } from '@mui/material';

import { AnalyticsDashboard } from 'components/Analytics/AnalyticsDashboard';

export const Analytics = () => {
  return (
    <Container maxWidth="xl">
      <Stack spacing={4}>
        {/* Page Header */}
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#2C3E50' }}>
            Analytics
          </Typography>
          <Typography variant="body2" sx={{ color: '#6B7280', mt: 0.5 }}>
            Monitor performance and insights for your agents
          </Typography>
        </Box>

        <AnalyticsDashboard />
      </Stack>
    </Container>
  );
};
